const videos = {
  intro: require("../assets/videos/intro.mp4"),
};

export default videos;
